import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { ClientsFetchAPI } from '../../../api/Clients';
import LoadingAlert from '../../Alerts/LoadingAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
import Select from 'react-select';
import Maps from '../../../utils/Maps';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const NewAddressForm = ({ setStatuslayout, getAddressClientNow, client_id, phoneClient }) => {
    const [typeAddress, setTypeAddress] = useState("")
    const [nameDirection, setNameDirection] = useState('')
    const [numberHouse, setNumberHouse] = useState('')
    const [phone, setPhone] = useState(phoneClient || '')
    const [additional_info, setadditional_info] = useState('')
    const [tables, setTables] = useState([]);
    const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 });
    const [prefixPhone, setPrefixPhone] = useState('507');
    let iconGeneral = ""
    if (localStorage.getItem('businessLogo') != null || localStorage.getItem('businessLogo') != undefined || localStorage.getItem('businessLogo') != "") {
        iconGeneral = localStorage.getItem('businessLogo')
    }

    let token = localStorage.getItem("x-access-machine-token")

    const cleanInputs = () => {
        setNameDirection('')
        setNumberHouse('')
        setPhone('')
        setadditional_info('')
        setStatuslayout(false)
    }

    const createAddressClient = async () => {
        let data = {
            "name": nameDirection,
            "lat": coordinates.lat,
            "lng": coordinates.lng,
            "phone": phone,
            "house_num": numberHouse,
            "client_id": client_id,
            "additional_info": additional_info
        }

        console.log(data);
        try {
            const response = await ClientsFetchAPI.createAddressClient(data, token);
            console.log(response);
            ErrorAlert("", "Direccion creada correctamente", "success")
            getAddressClientNow()
            cleanInputs()

        } catch (err) {
            ErrorAlert("", "Error al crear la direccion del cliente", "error")
        }
    }
    
    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="fw-bold mb-0"><i class="uil uil-map"></i> Crear direccion del cliente</h6>
            </div>

            <main className="dashboard-login-sp ">
                <div className='container login-container'>


                    <div className='row align-items-center'>
                        <div className="col-12 col-md-12 col-lg-12 col-xl-12 justify-content-center align-items-lg-center order-xxl-1 order-0">
                            <div className="border-0 rounded-4">
                                <div className=" p-0">
                                    <div className=' mt-lg-4'>
                                        <section className="bg-white">

                                            <div>
                                                <div className="row d-flex justify-content-center  justify-content-lg-center">
                                                    <div className="col-md-6 ">
                                                        <label className='form-label fw-bold text-black'>Buscar ubicacion </label>

                                                        <Maps modo="puntear-geolocator" position={setCoordinates} onClickCoordenada={coords => setCoordinates(coords)}
                                                            logo={iconGeneral} zoom={17} width={"100%"} height={"350px"} />
                                                    </div>

                                                    <div className='col-md-6 mt-5 mt-lg-0 '>
                                                        <div className='row'>
                                                            <div className="col-md-6 col-12 mt-4 mt-lg-0">
                                                                <label className="form-label fw-bold text-black">
                                                                    <i class="uil uil-estate"></i> Dirección
                                                                </label>
                                                                <div className='m-3'>
                                                                    <input
                                                                        type="radio"
                                                                        className="btn-check "
                                                                        name="btnradiotypeAddress"
                                                                        id="btnradiotypeAddress1"
                                                                        autoComplete="off"
                                                                        onChange={(e) => (setNameDirection("Casa"), setTypeAddress("Casa"))}
                                                                        checked={typeAddress === "Casa"}

                                                                    />
                                                                    <label className="btn btn-outline-primary border rounded-pill " htmlFor="btnradiotypeAddress1">
                                                                        <small className='fw-bold mx-1'><i class="uil uil-estate"></i> Casa</small>
                                                                    </label>

                                                                    <input
                                                                        type="radio"
                                                                        className="btn-check "
                                                                        name="btnradiotypeAddress"
                                                                        id="btnradiotypeAddress2"
                                                                        autoComplete="off"
                                                                        onChange={(e) => (setNameDirection("Trabajo"), setTypeAddress("Trabajo"))}
                                                                        checked={typeAddress === "Trabajo"}
                                                                    />
                                                                    <label className="btn btn-outline-primary border rounded-pill mx-1" htmlFor="btnradiotypeAddress2">
                                                                        <small className='fw-bold mx-1'><i class="uil uil-constructor"></i> Trabajo</small>
                                                                    </label>
                                                                    <input
                                                                        type="radio"
                                                                        className="btn-check  "
                                                                        name="btnradiotypeAddress"
                                                                        id="btnradiotypeAddress3"
                                                                        autoComplete="off"
                                                                        onChange={(e) => (setTypeAddress("Otro"))}
                                                                        checked={typeAddress === "Otro"}
                                                                    />
                                                                    <label className="btn btn-outline-primary border rounded-pill" htmlFor="btnradiotypeAddress3">
                                                                        <small className='fw-bold mx-1'><i class="uil uil-archway"></i> Otro</small>
                                                                    </label>
                                                                </div>
                                                                {typeAddress === "Otro" && <input
                                                                    type={'text'}
                                                                    className="form-control rounded-3 border-1 text-muted"
                                                                    id="text"
                                                                    name='pass'
                                                                    placeholder="Ingresar nombre de la dirección"
                                                                    required
                                                                    spellcheck="false" onChange={(e) => setNameDirection(e.target.value)}
                                                                />}
                                                            </div>
                                                            <div className="col-md-6 col-12 mt-4 mt-lg-0">
                                                                <label className="form-label fw-bold text-black">
                                                                    <i class="uil uil-clinic-medical"></i> Núm de casa o apartamento
                                                                </label>
                                                                <input
                                                                    type={'text'}
                                                                    className="form-control rounded-3 border-1 text-muted"
                                                                    id="text"
                                                                    name='pass'
                                                                    placeholder="#45"
                                                                    required
                                                                    spellcheck="false" onChange={(e) => setNumberHouse(e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="col-md-12 col-12 mt-4 mt-lg-2">
                                                                <label className="form-label fw-bold text-black">
                                                                    <i class="uil uil-phone"></i> Número de teléfono de dirección
                                                                </label>

                                                                <PhoneInput
                                                                    country={'pa'}
                                                                    value={phone}
                                                                    onChange={phone => (setPhone(phone))}
                                                                    inputProps={{
                                                                        name: 'phone',
                                                                        required: true,
                                                                        autoFocus: true
                                                                    }}
                                                                    countryCodeEditable={false}
                                                                    masks={{ pa: '.... ....' }} 
                                                                    enableSearch
                                                                />
                                                            </div>
                                                            <div className="col-md-12 col-12 mt-4 mt-lg-2">
                                                                <label className="form-label fw-bold text-black">
                                                                    <i class="uil uil-comment-notes"></i> Notas adicionales o referencias
                                                                </label>
                                                                <input
                                                                    type={'text'}
                                                                    className="form-control rounded-3 border-1 text-muted"
                                                                    id="text"
                                                                    name='pass'
                                                                    placeholder="Notas o referencias de la ubicacion"
                                                                    required
                                                                    spellcheck="false" onChange={(e) => setadditional_info(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className='d-flex justify-content-between m-3'>
                                                            <button className='btn bg-danger-subtle text-danger  border-0 fw-bold ' onClick={() => (cleanInputs())}>
                                                                <i class="uil uil-times-circle"></i> Cancelar
                                                            </button>
                                                            <button className='btn bg-success-subtle text-success  border-0 fw-bold ' onClick={() => createAddressClient()} >
                                                                <i class="uil uil-save"></i> Guardar
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>



                                            </div>

                                            <footer >
                                                <div className='container d-lg-flex justify-content-between align-content-center align-items-center w-100 text-center text-secondary'>
                                                    <div className=''>
                                                        <small className='opacity-50'>
                                                            <i class="uil uil-copyright"></i> 2025 Smart Pay
                                                        </small>
                                                    </div>
                                                    <div>

                                                        <small className='opacity-50'>
                                                            <i class="uil uil-bolt"></i> Powered by Smart Retail Group
                                                        </small>
                                                    </div>
                                                </div>

                                            </footer>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

        </>
    )
}

export default NewAddressForm